$(document).ready(function () {
	if (window.innerWidth >= 320) {
		// UpFadeIn Animation
		if ($(".slideshow__text-wrapper").hasClass("up-fade-in-animation") && window.animation.upFadeInAnimation) {
			setTimeout(() => {
				$('[text-up-fadein="true"]').addClass("animation-up");
			}, 150);
		}

		// SlideShow Parallex Animation
		gsap.to(".parallax img", {
			yPercent: 50,
			ease: "none",
			scrollTrigger: {
				trigger: ".parallax",
				start: "top top",
				end: "bottom top",
				scrub: 0.3,
			},
		});

		//Animation center text (dedicated for static/relative)
		function scrollDefault(anim, trigger, once) {
			ScrollTrigger.create({
				animation: anim,
				trigger: trigger,
				start: () => "top 130%",
				end: () => "bottom 110%",
				scrub: 2,
				once: once,
				invalidateOnRefresh: true,
			});
		}

		//Animation center text (dedicated for static/relative)
		function textToCenterNormal() {
			var textToCenterElement = document.querySelectorAll('[text-to-center="true"]');
			if(window,innerWidth >= 1024){
				textToCenterElement.forEach((element) => {
					var left = element.getAttribute("position-left");
					var thisWidth = element.offsetWidth;
					var thisPadding = left ? element.getBoundingClientRect().left : window.innerWidth - element.getBoundingClientRect().right;
					var dist = (window.innerWidth - thisWidth) / 2 - thisPadding;
					gsap.set(element, { x: left ? -dist : dist + 350 });

					const textAbsolute = gsap.to(element, {
						x: 0,
						ease: "power1.out",
					});
					scrollDefault(textAbsolute, element, false);
				});
			}else{
				textToCenterElement.forEach((element) => {
					let left = element.getAttribute("position-left");
					let thisWidth = element.offsetWidth;
					let thisPadding = left ? element.getBoundingClientRect().left : window.innerWidth - element.getBoundingClientRect().right;
					let dist = (window.innerWidth - thisWidth) / 2 - thisPadding;
					gsap.set(element, { x: left ? -dist : dist + 150 });

					const textAbsolute = gsap.to(element, {
						x: 0,
						ease: "power1.out",
					});
					scrollDefault(textAbsolute, element, false);
				});
			}
		}
		textToCenterNormal();

		function textColorChange() {
			let textColorChange = document.querySelectorAll('[text-color-change="true"] p');
			textColorChange.forEach((element) => {
				let splitAnim = new SplitType(element, { types: "words, chars" });
				const splitWords = splitAnim.words;
				let splitTextAnim = gsap.to(splitWords, {
					color: "#453536",
					stagger: 0.1,
					ease: "steps(0.5)",
				});
				scrollDefault(splitTextAnim, element, false);
			});
		}
		textColorChange();

		// ImageUp Animation
		var imageUp = document.querySelector('[image-to-up="true"]');
		if(window.innerWidth > 1024){
			var imageAbsolute = gsap.to(imageUp, {
				duration: 2.8,
				height: "911",
			},
			"<+1.4"
			);
			ScrollTrigger.create({
				animation: imageAbsolute,
				trigger: ".section-feature",
				start: () => "top 150%",
				end: () => "bottom 120%",
				scrub: true,
				once: false,
			});
		}else{
			if(window.innerWidth <= 1024 && window.innerWidth > 768){
				var imageAbsolute = gsap.to(imageUp, {
					duration: 2.8,
					height: "486",
				},
				"<+0.5"
				);
				ScrollTrigger.create({
					animation: imageAbsolute,
					trigger: ".section-feature",
					start: () => "top 150%",
					end: () => "bottom 120%",
					scrub: true,
					once: false,
				});
			}
			if(window.innerWidth <= 768){
				var imageAbsolute = gsap.to(imageUp, {
					duration: 2.8,
					height: "310",
				},
				"<+0.5"
				);
				ScrollTrigger.create({
					animation: imageAbsolute,
					trigger: ".section-feature",
					start: () => "top 150%",
					end: () => "bottom 120%",
					scrub: true,
					once: false,
				});
			}
		}

		
		if(window.innerWidth > 768){
			// On Scroll Image Size Increase and Round Corner Function
			const sectionsSlides = document.querySelectorAll(".slider-co-block");
			const container = document.querySelector(".osslider-container");
			const scrollImages = document.querySelectorAll(".slider-co-block .scroll-sl-image img");
			
			var defaultWidth = 430;
			// var defaultHeight = 514;
			var finalWidth = 500;
			// var finalHeight = 725;
			if(window.innerWidth <= 1536){
				defaultWidth = 380;
				finalWidth = 450;
			}
			if(window.innerWidth <= 1366){
				defaultWidth = 380;
				finalWidth = 400;
			}
			if(window.innerWidth <= 1024){
				defaultWidth = 280;
				finalWidth = 380;
				// finalHeight = 625;
			}
			if(window.innerWidth <= 768){
				defaultWidth = 190;
				finalWidth = 300;
				// finalHeight = 625;
			}
			if(window.innerWidth <= 540){
				defaultWidth = 180;
				finalWidth = 220;
				// finalHeight = 625;
			}

			scrollImages.forEach((image, index) => {
				if (index === 0) {
					image.style.width = `${finalWidth}px`;
					image.style.borderRadius = `110px 110px`;
				} else {
					image.style.width = `${defaultWidth}px`;
					image.style.borderRadius = `0px 0px`;
				}
			});

			let sideAnim = gsap.timeline({
				scrollTrigger: {
					trigger: ".scroll-slider",
					start: "top top",
					end: `+=${container.offsetWidth * 1.5}`,
					pin: true,
					duration: 2.5,
					ease: "power4.Out",
					scrub: 2,
					invalidateOnRefresh: true,
					onUpdate: (self) => {
						const progress = self.progress;
						scrollImages.forEach((image, index) => {
							let scaleValue, newWidth, newHeight, borderRadiusValue;
							const slideIndex = Math.floor(index / 2);
							const slideProgress = Math.max(
								0,
								Math.min(
									1,
									(progress - slideIndex * (1 / sectionsSlides.length)) *
										sectionsSlides.length
								)
							);
							scaleValue = slideProgress;

							if (index === 0) {
								newWidth = finalWidth;
								// newHeight = finalHeight;
								borderRadiusValue = 110;
							} else {
								newWidth = Math.min(
									finalWidth,
									defaultWidth + (finalWidth - defaultWidth) * scaleValue
								);
								// newHeight = Math.min(
								// 	finalHeight,
								// 	defaultHeight + (finalHeight - defaultHeight) * scaleValue
								// );
								borderRadiusValue = 110 * scaleValue;
							}

							image.style.width = `${newWidth}px`;
							// image.style.height = `${newHeight}px`;
							image.style.borderRadius = `${borderRadiusValue}px ${borderRadiusValue}px`;
						});
					},
				},
			});


			if(window.innerWidth >= 768){
				sideAnim.to(sectionsSlides, {
					xPercent: -100 * (sectionsSlides.length - 1),
				});
			}else{
				sideAnim.to(sectionsSlides, {
					xPercent: -105 * (sectionsSlides.length - 1),
				});
			}

			sideAnim.add(() => {
				ScrollTrigger.refresh();
			});
		}

		if(window.innerWidth >= 768){
			const paragraphAndLists = document.querySelectorAll('.scroll-sl-paragraph:not(.scroll-sl-paragraphn)[text-color-change="true"]');
			paragraphAndLists.forEach((element, index) => {
					let startValue, endValue;
					
					if (element.classList.contains('block-index--1')) {
						startValue = 'top 80%';
						endValue = 'top 65%';
					} else if (element.classList.contains('block-index--2')) {
						startValue = 'top 50%';
						endValue = 'top 35%';
					} else if (element.classList.contains('block-index--3')) {
						startValue = 'top 20%';
						endValue = 'top 5%';
					} else if (element.classList.contains('block-index--4')) {
						startValue = 'bottom -10%';
						endValue = 'bottom -25%';
					} else if (element.classList.contains('block-index--5')) {
						startValue = 'bottom -40%';
						endValue = 'bottom -55%';
					}

					const pTag = gsap.timeline({
						scrollTrigger: {
							trigger: element,
							start: startValue,
							end: endValue,
							scrub: 2,
							once: false,
							invalidateOnRefresh: true,
							id: index + 1
						},
					});

					const pElement = element.querySelector("p");
					if (pElement) {
							let splitPAnim = new SplitType(pElement, { types: "words, chars" });
							const splitPWords = splitPAnim.words;
							pTag.to(splitPWords, {
									color: "#453536",
									stagger: 0.1,
									ease: "steps(0.1)",
							});
					}

					const ulElement = element.querySelector("ul");
					if (ulElement) {
						const liElements = ulElement.querySelectorAll("li");
						liElements.forEach((li, liIndex) => {
							let splitLiAnim = new SplitType(li, { types: "words, chars" });
							const splitLiWords = splitLiAnim.words;
							pTag.to(splitLiWords,{
								color: "#453536",
								stagger: 0.05,
								ease: "steps(0.1)",
							});
						});
					}
			});
			// Heading Fade In Animation Function
			function fadeinHeading() {
				let fadeInElement = document.querySelectorAll('[text-fade-in="true"]');
				fadeInElement.forEach((element, index) => {
					var fadeText = gsap.fromTo(element,{
						autoAlpha: 0,
					},
					{
						duration: 2,
						autoAlpha: 1,
					});
					onScrollFadeIn(fadeText, element, false, index);
				});
			}
			fadeinHeading();
			function onScrollFadeIn(anim, trigger, once, index) {
				const endLength = `+=${550 * index}px`;
				ScrollTrigger.create({
					animation: anim,
					trigger: trigger,
					start: () => "left 70%",
					end: () => endLength,
					once: once,
					invalidateOnRefresh: true,
				});
			}
		}


		// if(window.innerWidth > 768){
			// Timeline for the first animation (Image Fullscreen)
			function onImageFullScreen() {				
				if(window.innerWidth >= 1024){
					var onImage = gsap.timeline({
						scrollTrigger: {
							trigger: ".image-with-content.co-left",
							start: "center center",
							end: "bottom center",
							pin: true,
							scrub: 4,
						}
					});
				}
				
				if(window.innerWidth >= 1745){
					onImage.to(".image-with-content.co-left .co-image", {
						top: "-90px",
						right: "-70px",
						height: "145%",
						width: "110%",
						ease: "power4.Out",
						duration: 10,
					});
				}else if(window.innerWidth >= 1650){
					onImage.to(".image-with-content.co-left .co-image", {
						top: "-90px",
						right: "-70px",
						height: "150%",
						width: "110%",
						ease: "power4.Out",
						duration: 10,
					});
				}else if(window.innerWidth >= 1536){
					onImage.to(".image-with-content.co-left .co-image", {
						top: "-120px",
						right: "-70px",
						height: "160%",
						width: "110%",
						ease: "power4.Out",
						duration: 10,
					});
				}else if(window.innerWidth >= 1440){
					onImage.to(".image-with-content.co-left .co-image", {
						top: "-150px",
						right: "-70px",
						height: "830px",
						width: "1480px",
						ease: "power4.Out",
						duration: 10,
					});
				}else if(window.innerWidth >= 1366){
					onImage.to(".image-with-content.co-left .co-image", {
						top: "-150px",
						right: "-70px",
						height: "800px",
						width: "1380px",
						ease: "power4.Out",
						duration: 10,
					});
				}else if(window.innerWidth >= 1200){
					onImage.to(".image-with-content.co-left .co-image", {
						top: "-150px",
						right: "-70px",
						height: "710px",
						width: "1250px",
						ease: "power4.Out",
						duration: 10,
					});
				}else if(window.innerWidth >= 1024){
					onImage.to(".image-with-content.co-left .co-image", {
						top: "-185px",
						right: "-70px",
						height: "710px",
						width: "1080px",
						ease: "power4.Out",
						duration: 10,
					});
				}else if(window.innerWidth >= 768){
					console.log("768");
					var onImage = gsap.timeline({
						scrollTrigger: {
							trigger: ".image-with-content.co-left",
							start: "top -10%",
							end: "bottom 1%",
							pin: true,
							scrub: 4,
						}
					});
					onImage.to(".image-with-content.co-left .co-image.mobile-image", {
						right: "-25px",
						width: "780",
						height: "655",
						ease: "power4.Out",
						duration: 10,
					});
				}else if(window.innerWidth >= 540){
					var onImage = gsap.timeline({
						scrollTrigger: {
							trigger: ".image-with-content.co-left",
							start: "top -35%",
							end: "bottom 1%",
							pin: true,
							scrub: 2,
						}
					});
					onImage.to(".image-with-content.co-left .co-image.mobile-image", {
						right: "-20px",
						width: "560",
						height: "750",
						ease: "power4.Out",
						duration: 10,
					});
				}else if(window.innerWidth >= 430){
					var onImage = gsap.timeline({
						scrollTrigger: {
							trigger: ".image-with-content.co-left",
							start: "top -35%",
							end: "bottom 1%",
							pin: true,
							scrub: 2,
						}
					});
					onImage.to(".image-with-content.co-left .co-image.mobile-image", {
						right: "-20px",
						width: "440",
						height: "750",
						ease: "power4.Out",
						duration: 10,
					});
				}else if(window.innerWidth >= 414){
					var onImage = gsap.timeline({
						scrollTrigger: {
							trigger: ".image-with-content.co-left",
							start: "top -35%",
							end: "bottom 1%",
							pin: true,
							scrub: 2,
						}
					});
					onImage.to(".image-with-content.co-left .co-image.mobile-image", {
						right: "-20px",
						width: "440",
						height: "620",
						ease: "power4.Out",
						duration: 10,
					});
				}else if(window.innerWidth >= 320){
					var onImage = gsap.timeline({
						scrollTrigger: {
							trigger: ".image-with-content.co-left",
							start: "top -35%",
							end: "bottom 1%",
							pin: true,
							scrub: 2,
						}
					});
					onImage.to(".image-with-content.co-left .co-image.mobile-image", {
						right: "-20px",
						width: "400",
						height: "620",
						ease: "power4.Out",
						duration: 10,
					});
				}

				// UP ANIMATION JS
				if(window.innerWidth >= 1650){
					onImage.to(".image-overlay-content",{
						opacity: 1,
						y: "-94%",
						right: "0px",
						x: "0%",
						duration: 5,
						ease: "power4.inOut",
						onUpdate: function () {
							setTimeout(() => {
								$(".image-overlay-content .box-wrapper-animation").addClass("animation-up");
							}, 950);
						},
					},"-=4.5");
				}
				else if(window.innerWidth >= 1536){
					onImage.to(".image-overlay-content",{
						opacity: 1,
						y: "-100%",
						right: "0px",
						x: "0%",
						duration: 5,
						ease: "power4.inOut",
						onUpdate: function () {
							setTimeout(() => {
								$(".image-overlay-content .box-wrapper-animation").addClass("animation-up");
							}, 900);
						},
					},"-=5.5");	}
					else if(window.innerWidth >= 1366){
						onImage.to(".image-overlay-content",{
							opacity: 1,
							y: "-94%",
							right: "0px",
							x: "0%",
							duration: 5,
							ease: "power4.inOut",
							onUpdate: function () {
								setTimeout(() => {
									$(".image-overlay-content .box-wrapper-animation").addClass("animation-up");
								}, 950);
							},
						},"-=5.5");	}
				else if(window.innerWidth >= 1024){
					onImage.to(".image-overlay-content",{
						opacity: 1,
						y: "-100%",
						right: "0px",
						x: "0%",
						duration: 5,
						ease: "power4.inOut",
						onUpdate: function () {
							setTimeout(() => {
								$(".image-overlay-content .box-wrapper-animation").addClass("animation-up");
							}, 900);
						},
					},'-=5');
				}else if(window.innerWidth >= 768){
					onImage.to(".image-overlay-content",{
						opacity: 1,
						y: "-150%",
						right: "0px",
						x: "0%",
						duration: 5,
						ease: "power4.inOut",
						onUpdate: function () {
							setTimeout(() => {
								$(".image-overlay-content .box-wrapper-animation").addClass("animation-up");
							}, 850);
						},
					},'-=5.5');
				}else if(window.innerWidth >= 540){
					onImage.to(".image-overlay-content",{
						opacity: 1,
						y: "-165%",
						right: "0px",
						x: "0%",
						duration: 5,
						ease: "power4.inOut",
						onUpdate: function () {
							setTimeout(() => {
								$(".image-overlay-content .box-wrapper-animation").addClass("animation-up");
							}, 750);
						},
					},'-=6');
				}else if(window.innerWidth >= 430){
					onImage.to(".image-overlay-content",{
						opacity: 1,
						y: "-270%",
						right: "0px",
						x: "0%",
						duration: 5,
						ease: "power4.inOut",
						onUpdate: function () {
							setTimeout(() => {
								$(".image-overlay-content .box-wrapper-animation").addClass("animation-up");
							}, 750);
						},
					},'-=6');
				}else if(window.innerWidth >= 425){
					onImage.to(".image-overlay-content",{
						opacity: 1,
						y: "-235%",
						right: "0px",
						x: "0%",
						duration: 5,
						ease: "power4.inOut",
						onUpdate: function () {
							setTimeout(() => {
								$(".image-overlay-content .box-wrapper-animation").addClass("animation-up");
							}, 750);
						},
					},'-=6');
				}else if(window.innerWidth >= 414){
					onImage.to(".image-overlay-content",{
						opacity: 1,
						y: "-210%",
						right: "0px",
						x: "0%",
						duration: 5,
						ease: "power4.inOut",
						onUpdate: function () {
							setTimeout(() => {
								$(".image-overlay-content .box-wrapper-animation").addClass("animation-up");
							}, 750);
						},
					},'-=6');
				}else if(window.innerWidth > 376){
					onImage.to(".image-overlay-content",{
						opacity: 1,
						y: "-220%",
						right: "0px",
						x: "0%",
						duration: 5,
						ease: "power4.inOut",
						onUpdate: function () {
							setTimeout(() => {
								$(".image-overlay-content .box-wrapper-animation").addClass("animation-up");
							}, 250);
						},
					},'-=6');
				}else if(window.innerWidth > 326){
					onImage.to(".image-overlay-content",{
						opacity: 1,
						y: "-220%",
						right: "0px",
						x: "0%",
						duration: 5,
						ease: "power4.inOut",
						onUpdate: function () {
							setTimeout(() => {
								$(".image-overlay-content .box-wrapper-animation").addClass("animation-up");
							}, 250);
						},
					},'-=6');
				}
				else if(window.innerWidth >= 320){
					onImage.to(".image-overlay-content",{
						opacity: 1,
						y: "-210%",
						right: "0px",
						x: "0%",
						duration: 5,
						ease: "power4.inOut",
						onUpdate: function () {
							setTimeout(() => {
								$(".image-overlay-content .box-wrapper-animation").addClass("animation-up");
							}, 250);
						},
					});
				}
				onImage.add(() => {
					ScrollTrigger.refresh();
				});
			}			
			onImageFullScreen();
		// }

		// Word Transition Animation
		var textTransition = $(".personalize-bottom div").attr("word-value");
		if(textTransition){
			const words = textTransition.split(",");
			let wordIndex = 0;

			const wordTransition = document.querySelector('[word-transition="true"] p');
			function transitionWords() {
				gsap.to(wordTransition, {
					opacity: 0.5,
					y: -65,
					duration: 1.5,
					onComplete: () => {
						wordIndex = (wordIndex + 1) % words.length;
						wordTransition.textContent = words[wordIndex];
						gsap.set(wordTransition, { y: 65 });
						gsap.to(wordTransition, {
							y: 0,
							opacity: 1,
							duration: 1,
							onComplete: transitionWords,
						});
					},
				});
			}
			transitionWords();
		}

	}
	if(window.innerWidth < 768){
		function textColorChange() {
			let textColorChange = document.querySelectorAll('[text-color-change="true"] p');
			textColorChange.forEach((element) => {
				let splitAnim = new SplitType(element, { types: "words, chars" });
				const splitWords = splitAnim.words;
				let splitTextAnim = gsap.to(splitWords, {
					color: "#453536",
					stagger: 0.1,
					ease: "steps(0.5)",
				});
				scrollDefault(splitTextAnim, element, false);
			});
		}
		textColorChange();

		//Animation center text (dedicated for static/relative)
		function scrollDefault(anim, trigger, once) {
			ScrollTrigger.create({
				animation: anim,
				trigger: trigger,
				start: () => "top 130%",
				end: () => "bottom 80%",
				scrub: 2,
				once: once,
				invalidateOnRefresh: true,
			});
		}

		// const mobileParagraphAndLists = document.querySelectorAll('.scroll-sl-paragraph[text-color-change="true"]');
		// mobileParagraphAndLists.forEach((element, index) => {
		// 		let startValue, endValue;
				
		// 		if (element.classList.contains('block-index--1')) {
		// 			startValue = 'top 95%';
		// 			endValue = 'top 85%';
		// 		} else if (element.classList.contains('block-index--2')) {
		// 			startValue = 'top 75%';
		// 			endValue = 'top 65%';
		// 		} else if (element.classList.contains('block-index--3')) {
		// 			startValue = 'top 50%';
		// 			endValue = 'top 40%';
		// 		} else if (element.classList.contains('block-index--4')) {
		// 			startValue = 'top 30%';
		// 			endValue = 'top 20%';
		// 		} else if (element.classList.contains('block-index--5')) {
		// 			startValue = 'bottom 10%';
		// 			endValue = 'bottom -1%';
		// 		}

		// 		const pTag = gsap.timeline({
		// 			scrollTrigger: {
		// 				trigger: element,
		// 				start: startValue,
		// 				end: endValue,
		// 				scrub: 2,
		// 				once: false,
		// 				invalidateOnRefresh: true,
		// 				id: index + 1
		// 			},
		// 		});

		// 		const pElement = element.querySelector("p");
		// 		if (pElement) {
		// 				let splitPAnim = new SplitType(pElement, { types: "words, chars" });
		// 				const splitPWords = splitPAnim.words;
		// 				pTag.to(splitPWords, {
		// 						color: "#453536",
		// 						stagger: 0.1,
		// 						ease: "steps(0.1)",
		// 				});
		// 		}

		// 		const ulElement = element.querySelector("ul");
		// 		if (ulElement) {
		// 			const liElements = ulElement.querySelectorAll("li");
		// 			liElements.forEach((li, liIndex) => {
		// 				let splitLiAnim = new SplitType(li, { types: "words, chars" });
		// 				const splitLiWords = splitLiAnim.words;
		// 				pTag.to(splitLiWords,{
		// 					color: "#453536",
		// 					stagger: 0.05,
		// 					ease: "steps(0.1)",
		// 				});
		// 			});
		// 		}
		// });
		// }

		function fadeinHeading() {
			let fadeInElement = document.querySelectorAll('[text-fade-in="true"]');
			fadeInElement.forEach((element, index) => {
				var fadeText = gsap.fromTo(element,{
					autoAlpha: 0,
				},
				{
					duration: 2,
					autoAlpha: 1,
				});
				onScrollFadeIn(fadeText, element, false, index);
			});
		}
		fadeinHeading();
		function onScrollFadeIn(anim, trigger, once, index) {
			const endLength = `+=${550 * index}px`;
			ScrollTrigger.create({
				animation: anim,
				trigger: trigger,
				start: () => "left 85%",
				end: () => endLength,
				once: once,
				invalidateOnRefresh: true
			});
		}
	}
});
